import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const SleeperTrain = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.5281 0.452484V1.33885H15.6857L12.5281 3.99794V4.8843H16.9599V3.99794H13.8022L16.9599 1.33885V0.452484H12.5281ZM18.7326 3.11158V3.99794H21.036L18.7326 6.65703V7.54339H22.2781V6.65703H19.9998L22.2781 3.99794V3.11158H18.7326ZM14.3008 6.65703V7.54339H16.0874L14.3043 9.31612L14.3008 9.32045V10.2025H17.4031V9.31612H15.6407L17.4031 7.54339V6.65703H14.3008Z" />;
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M11.4952 2.9348C11.4758 3.04698 11.4656 3.16266 11.4656 3.2811V7.92123V9.54623V11.9212C11.4656 12.4732 11.9136 12.9212 12.4656 12.9212H17.4656C18.0176 12.9212 18.4656 12.4732 18.4656 11.9212V9.23166C18.5835 9.19246 18.7095 9.17123 18.8406 9.17123H19.8406C20.0588 9.17123 20.2689 9.13627 20.4656 9.07164V19.9212C20.4656 21.8634 19.0807 23.4784 17.2449 23.8412L18.7839 26.9212H16.4656L14.9656 23.9212H5.96558L4.46558 26.9212H2.14722L3.68628 23.8412C1.85046 23.4784 0.465576 21.8634 0.465576 19.9212V6.92123C0.465576 5.26423 2.46558 2.92123 10.4656 2.92123C10.8205 2.92123 11.1636 2.92585 11.4952 2.9348ZM8.46558 6.92123H3.46558C2.91358 6.92123 2.46558 7.36923 2.46558 7.92123V11.9212C2.46558 12.4732 2.91358 12.9212 3.46558 12.9212H8.46558C9.01758 12.9212 9.46558 12.4732 9.46558 11.9212V7.92123C9.46558 7.36923 9.01758 6.92123 8.46558 6.92123ZM6.46558 19.4212C6.46558 18.5932 5.79358 17.9212 4.96558 17.9212C4.13758 17.9212 3.46558 18.5932 3.46558 19.4212C3.46558 20.2492 4.13758 20.9212 4.96558 20.9212C5.79358 20.9212 6.46558 20.2492 6.46558 19.4212ZM17.4656 19.4212C17.4656 18.5932 16.7936 17.9212 15.9656 17.9212C15.1376 17.9212 14.4656 18.5932 14.4656 19.4212C14.4656 20.2492 15.1376 20.9212 15.9656 20.9212C16.7936 20.9212 17.4656 20.2492 17.4656 19.4212Z" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <IconWrapper {...props} variant="solid" viewBox="0 0 23 27">{t1}{t2}</IconWrapper>;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { SleeperTrain };